<template>
  <div id="header">
    <v-navigation-drawer
      v-model="sidebar"
      app
      disable-resize-watcher
    >
      <v-list>
        <v-list-item
          v-for="menuItem in menuItems"
          :key="menuItem.title"
          :to="menuItem.path"
        >
          <v-list-item-action>
            <v-icon>mdi-{{ menuItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>{{ menuItem.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      color="white"
      elevate-on-scroll
    >
      <span class="hidden-md-and-up">
        <v-app-bar-nav-icon class="mr-3" @click="sidebar = !sidebar"></v-app-bar-nav-icon>
      </span>
      <router-link to="/">
        <v-img
          :src="require('../assets/traverse-logo.svg')"
          style="width: 200px; height: 39px;"
          contain
        ></v-img>
      </router-link>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn
          text color="#273245"
          v-for="menuItem in menuItems"
          :key="menuItem.title"
          :to="menuItem.path"
          class="mx-3"
        >
          <v-icon left>mdi-{{ menuItem.icon }}</v-icon>
          {{ menuItem.title }}
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    
        <!-- <v-app-bar
            app
            color="white"
            height="80"
        >
            <router-link to="/">
                <v-img
                    contain
                    class="mx-2"
                    width="250"
                    :src="require('../assets/traverse-logo.png')"
                ></v-img>
            </router-link>

            <v-spacer></v-spacer>

            <router-link
                to="#about"
                style="margin-left: 100px; font-weight: bolder;"
            >
                <v-btn>
                    <v-icon>mdi-checkerboard</v-icon>
                    <span style="padding-left: 5px;">About</span>
                </v-btn>
            </router-link>
            <router-link
                to="#videos"
                style="margin-left: 50px; font-weight: bolder;"
            
                ><v-btn>
                    <v-icon>mdi-video</v-icon>
                    <span style="padding-left: 5px;">Videos</span>
                </v-btn>
            </router-link>
        </v-app-bar> -->

    </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        appTitle: 'Traverse',
        sidebar: false,
        menuItems: [
          { title: 'About', path: '#about', icon: 'checkerboard' },
          { title: 'Videos', path: '#videos', icon: 'video' },
          { title: 'Buy', path: '#buy', icon: 'point-of-sale' },
          // { title: 'Contact', path: '#contact', icon: 'pencil' }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
    header,
    nav {
      font-family: Roboto;
    }
</style>
